import "./bootstrap";
import { Tooltip, Offcanvas } from "bootstrap";
import { initUserWebLifetime } from "./plugin/user-lifetime";
// import { jarallax } from "jarallax";
// import 'jarallax/dist/jarallax.min.css';
import "smooth-scroll";
import Swiper from "swiper";

import Tbx from "tbxjs";
import * as components from "./ui/components";
import * as inputComponents from "./ui/form";
import * as customComponents from "./components";

initUserWebLifetime();

Tbx.registerComponents(components);
Tbx.registerComponents(inputComponents);
Tbx.registerComponents(customComponents);
Tbx.init();

// Модальные окна
document.querySelectorAll("[ui-modal-target]").forEach((element) => {
    let modalId = element.getAttribute("ui-modal-target");
    let target = document.querySelector(modalId);
    if (target && (target = Tbx.getComponentByElement(target))) {
        element.addEventListener("click", (e) => {
            // console.log(target);
            e.preventDefault();
            target.show();
        });
    }
});

// Swiper для слайдера
document.querySelectorAll(".swiper").forEach((element) => {
    new Swiper(
        element,
        JSON.parse(element.getAttribute("data-swiper-options"))
    );
});

// Эффект для кнопки Купить подписку
document.addEventListener("DOMContentLoaded", () => {
    const element = document.querySelector(".promo-effect");
    if (!element) return;
    let angle = 0;
    const rotate = () => {
        angle = (angle + 2) % 360; // Increment angle and keep it within 0-360
        element?.style.setProperty("--angle", `${angle}deg`);
        requestAnimationFrame(rotate);
    };

    rotate();
});

// Инициализация всех найденных тултипов
[].slice
    .call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    .forEach((node) => {
        new Tooltip(node);
    });


// Переход по якорям бургер меню в мобильной версии
document.addEventListener("click", function (event) {
    if (window.innerWidth >= 992) return;
    if (event.target.closest(".dropdown-toggle, [data-bs-toggle='dropdown']")) {
        return;
    }
    const link = event.target.closest("#navbarNav a[href*='#']");
    if (!link) return;

    const href = link.getAttribute("href");
    if (!href) return;

    const url = new URL(href, window.location.origin);
    const currentPath = window.location.pathname.replace(/\/+$/, "");
    const linkPath = url.pathname.replace(/\/+$/, "");
    const hashPart = decodeURIComponent(url.hash.replace(/^#/, ""));

    const samePage = linkPath === currentPath;
    const offcanvas = document.getElementById("navbarNav");
    const closeBtn = offcanvas?.querySelector(".btn-close");

    if (samePage && hashPart) {
        event.preventDefault();
        const targetElement = document.getElementById(hashPart);
        const scrollToTarget = () => {
            if (targetElement) {
                targetElement.scrollIntoView({ behavior: "smooth" });
            } else {
                // Fallback to native hash behavior if the element isn't found yet.
                window.location.hash = hashPart;
            }
        };

        if (offcanvas?.classList.contains("show")) {
            const onHidden = () => {
                offcanvas.removeEventListener("hidden.bs.offcanvas", onHidden);
                scrollToTarget();
            };
            offcanvas.addEventListener("hidden.bs.offcanvas", onHidden);
            if (closeBtn) {
                closeBtn.click();
            } else {
                (Offcanvas.getInstance(offcanvas) || new Offcanvas(offcanvas)).hide();
            }
        } else {
            scrollToTarget();
        }
    } else {
        if (closeBtn) closeBtn.click();
    }
});

//Предотвращает закрытие всплывашек
document.querySelectorAll('.dropdown-menu').forEach(menu => {
    menu.addEventListener('click', function (e) {
        if (!e.target.closest('a') && !e.target.closest('button')) {
            e.stopPropagation();
        }
    });
});

// Предотвращает показ offcanvas на больших экранах 
document.addEventListener('show.bs.offcanvas', function (event) {
    const offcanvas = event.target;

    if (offcanvas.id === "navbarNav") return;

    if (window.innerWidth >= 768) {
        event.preventDefault();
    }
});

// Cookie banner
document.addEventListener("DOMContentLoaded", function () {
    if (!localStorage.getItem("any2text_cookie_accepted")) {
        setTimeout(function () {
            const banner = document.getElementById("cookie-banner");
            if (banner) banner.style.display = "flex";
        }, 1500);
    }
    const acceptBtn = document.getElementById("cookie-accept-btn");
    if (acceptBtn) {
        acceptBtn.addEventListener("click", function () {
            localStorage.setItem("any2text_cookie_accepted", "true");
            const banner = document.getElementById("cookie-banner");
            if (banner) {
                banner.style.transition = "opacity 0.25s ease";
                banner.style.opacity = "0";
                setTimeout(() => { banner.style.display = "none"; }, 250);
            }
        });
    }
});

// Закрывает все offcanvas при изменении размера экрана на >= 768px
window.addEventListener('resize', function () {
    if (window.innerWidth >= 768) {

        document.querySelectorAll('.offcanvas.show, .offcanvas.showing').forEach(function (offcanvas) {
            const offcanvasInstance = Offcanvas.getInstance(offcanvas);
            if (offcanvasInstance) {
                offcanvasInstance.hide();
            }
        });
        document.querySelectorAll('.offcanvas-backdrop').forEach(function (backdrop) {
            backdrop.remove();
        });
    }
});

